import { FaClock, FaHome, FaMapMarkerAlt, FaPhone, FaStore, FaTruck } from 'react-icons/fa';
import './Delivery.css';

const Delivery = () => {
  return (
    <section className="delivery-section" id="delivery">
      <div className="container">
        <div className="delivery-options">
          <br>
          </br>
          <h2>वितरण सेवाहरू</h2>
          <p className="delivery-subtitle">तपाईंको सुविधा अनुसार वितरण विकल्पहरू</p>

          <div className="options">
            <div className="option">
              <div className="option-icon-wrapper">
                <FaTruck className="option-icon" />
              </div>
              <h3>घर वितरण</h3>
              <div className="option-details">
                <div className="detail-item">
                  <FaHome className="detail-icon" />
                  <span>घरमै वितरण उपलब्ध</span>
                </div>
                <div className="detail-item">
                  <FaClock className="detail-icon" />
                  <span>२४-४८ घण्टा भित्र</span>
                </div>
                <div className="detail-item">
                  <FaMapMarkerAlt className="detail-icon" />
                  <span>काठमाडौं उपत्यकामा</span>
                </div>
              </div>
            </div>

            <div className="option">
              <div className="option-icon-wrapper">
                <FaStore className="option-icon" />
              </div>
              <h3>स्टोर पिकअप</h3>
              <div className="option-details">
                <div className="detail-item">
                  <FaMapMarkerAlt className="detail-icon" />
                  <span>सिधै स्टोरबाट लिनुहोस्</span>
                </div>
                <div className="detail-item">
                  <FaClock className="detail-icon" />
                  <span>२४ घण्टा उपलब्ध</span>
                </div>
                <div className="detail-item">
                  <FaPhone className="detail-icon" />
                  <span>अग्रिम सूचना दिनुहोस्</span>
                </div>
              </div>

            </div>
          </div>

          <div className="delivery-info">
            <h3>वितरण सम्बन्धी जानकारी:</h3>
            <div className="info-grid">
              <div className="info-item">
                <div className="info-icon">⏰</div>
                <div className="info-content">
                  <h4>वितरण समय</h4>
                  <p>सोमबार - शनिबार: ९:०० बिहान - ७:०० बेलुका</p>
                  <p>आइतबार: १०:०० बिहान - ५:०० बेलुका</p>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon">📍</div>
                <div className="info-content">
                  <h4>वितरण क्षेत्र</h4>
                  <p>काठमाडौं, ललितपुर,</p>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon">📞</div>
                <div className="info-content">
                  <h4>सम्पर्क</h4>
                  <p>वितरण जानकारीको लागि:</p>
                  <p className="phone-number">+९७७ ९८५११९६०५६ </p>
                </div>
              </div>
            </div>
          </div>

          <div className="delivery-note">
            <p>⚠️ ध्यान दिनुहोस्: तुरुन्तै वितरणको लागि कृपया अग्रिम रूपमा आर्डर गर्नुहोस्।</p>
            <p>✓ सबै वितरण हाम्रा विश्वसनीय ड्राइभरहरूद्वारा गरिन्छ।</p>
          </div>
        </div>
      </div>
    </section >
  );
};

export default Delivery;